import { takeLatest, put } from "redux-saga/effects";
import { sagaActions } from "../actions";
import AquinaAPI from "../../../services/apis/aquina-axios";
import { setOrganizationPreference } from "../../organization";

const fetchOrganizationPreference = async (id) => {
  try {
    const response = await AquinaAPI.get("/portal/organization/preference?organizationId=" + id, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

function* getOrganizationPreference(action) {
  const { data } = yield fetchOrganizationPreference(action.id);
  yield put(setOrganizationPreference(data));
}

function* watchGetOrganizationPreference() {
  yield takeLatest(sagaActions.GET_ORGANIZATION_PREFERENCE, getOrganizationPreference);
}

export default watchGetOrganizationPreference;
